<form [formGroup]="courseTestForm" (ngSubmit)="saveCourseTest(inProgress)">
    <div class=" modal-header">
        <h5 class="modal-title d-flex align-items-center">
            <i class="bx bx-book me-1 font-20 text-primary"></i>{{courseTestForm.value.id?'Update':'Add'}} Course
            Test
        </h5>
        <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close"
            (click)="activeModal.close('Close')"></button>
    </div>
    <div class="modal-body">
        <div class="row g-3 mb-2">
            <div class="col-md-6">
                <label for="course" class="form-label">Course<b class="text-secondary">*</b></label>
                <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-book-reader'></i></span>
                    <ng-select class="form-control rcx-ng-select" formControlName="courseId" [clearable]="false"
                        ngbAutofocus placeholder="Select course"
                        [ngClass]="{'is-invalid': submitted && f.courseId.errors}">
                        <ng-option *ngFor=" let course of courses" [value]="course.id">{{course.name}}</ng-option>
                    </ng-select>
                    <div class="invalid-feedback" *ngIf="submitted && f.courseId.errors">
                        <span *ngIf="f.courseId.errors.required">Please
                            select a course .</span>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <label for="name" class="form-label">Name<b class="text-secondary">*</b></label>
                <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-user'></i></span>
                    <input type="text" class="form-control" id="name" formControlName="name" placeholder="Enter name"
                        [ngClass]="{'is-invalid': submitted && f.name.errors}" />
                    <div class="invalid-feedback" *ngIf="submitted && f.name.errors">
                        <span *ngIf="f.name.errors.required">Course name is
                            required.</span>
                        <span *ngIf="f.name.errors.pattern">Course name must be 1-250 chars.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <label for="code" class="form-label">Code<b class="text-secondary">*</b></label>
                <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-barcode'></i></span>
                    <input type="text" class="form-control" id="code" formControlName="code" placeholder="Enter code"
                        [value]="f['code'].value | uppercase" [ngClass]="{'is-invalid': submitted && f.code.errors}" />
                    <div class="invalid-feedback" *ngIf="submitted && f.code.errors">
                        <span *ngIf="f.code.errors.required">Course code is
                            required.</span>
                        <span *ngIf="f.code.errors.pattern">Code must be alphanumeric.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <label for="title" class="form-label">Title<b class="text-secondary">*</b></label>
                <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-heading'></i></span>
                    <input type="text" class="form-control" id="title" formControlName="title" placeholder="Enter title"
                        [ngClass]="{'is-invalid': submitted && f.title.errors}" />
                    <div class="invalid-feedback" *ngIf="submitted && f.title.errors">
                        <span *ngIf="f.title.errors.required">Title is
                            required.</span>
                        <span *ngIf="f.title.errors.pattern">Title must be 1-250 chars.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <label for="passingScore" class="form-label">Passing Score <b class="text-secondary">*</b></label>
                <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-check'></i></span>
                    <input type="number" class="form-control" id="passingScore" formControlName="passingScore"
                        placeholder="Enter score" [ngClass]="{'is-invalid': submitted && f.passingScore.errors}" />
                    <div class="invalid-feedback" *ngIf="submitted && f.passingScore.errors">
                        <span *ngIf="f.passingScore.errors.required">Passing score is required.</span>
                        <span *ngIf="f.passingScore.errors.min">Score must be at least 0.</span>
                        <span *ngIf="f.passingScore.errors.max">Score cannot be more than 100.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <label for="label" class="form-label">Description</label>
                <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-label'></i></span>
                    <input type="text" class="form-control" id="label" formControlName="label"
                        placeholder="Enter description" [ngClass]="{'is-invalid': submitted && f.label.errors}" />
                    <div class="invalid-feedback" *ngIf="submitted && f.label.errors">
                        <span *ngIf="f.label.errors.required">Description is
                            required.</span>
                        <span *ngIf="f.label.errors.pattern">Description must be 1-250 chars.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <label for="startDate" class="form-label">Start Date <b class="text-secondary">*</b></label>
                <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-calendar'></i></span>
                    <input type="date" class="form-control" id="startDate" formControlName="startDate"
                        [ngClass]="{'is-invalid': submitted && f.startDate.errors}" />
                    <div class="invalid-feedback" *ngIf="submitted && f.startDate.errors">
                        <span *ngIf="f.startDate.errors.required">Start date is required.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <label for="endDate" class="form-label">End Date <b class="text-secondary">*</b></label>
                <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-calendar'></i></span>
                    <input type="date" class="form-control" id="endDate" formControlName="endDate"
                        [ngClass]="{'is-invalid': submitted && f.endDate.errors}" />
                    <div class="invalid-feedback" *ngIf="submitted && f.endDate.errors">
                        <span *ngIf="f.endDate.errors.required">End date is required.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <label for="approvalStatus" class="form-label">Status</label>
                <div class="input-group">
                  <span class="input-group-text bg-transparent border-end-0">
                    <i class='bx bx-repost'></i>
                  </span>
                  <ng-select 
                    class="form-control rcx-ng-select" 
                    formControlName="approvalStatus"
                    placeholder="Select a Status" 
                    [clearable]="false"
                    [ngClass]="{'is-invalid': submitted && p?.approvalStatus?.errors}">
              
                    <!-- Dropdown items -->
                    <ng-option *ngFor="let status of statuses" [value]="status">
                      <span [ngClass]="getBadgeClassForStatus(status)">
                        {{ formatStatus(status) }}
                      </span>
                    </ng-option>
              
                    <!-- Selected item display -->
                    <ng-template ng-label-tmp let-item="item">
                      <span [ngClass]="getBadgeClassForStatus(item)">
                        {{ formatStatus(item) }}
                      </span>
                    </ng-template>
                  </ng-select>
              
                  <div class="invalid-feedback" *ngIf="submitted && p?.approvalStatus?.errors">
                    <span *ngIf="p?.approvalStatus?.errors?.required">Please select a Status</span>
                  </div>
                </div>
              </div>
              
            <div class="col-md-auto">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="disabled" formControlName="disabled">
                    <label class="form-check-label" for="disabled">Disabled</label>
                </div>
            </div>
            <div class="col-lg-auto ms-auto">
                <button type="submit" class="btn btn-secondary rcx-btn" #inProgress
                    [ngClass]="{'no-event':inProgress?.value=='true'}">
                    <ng-container *ngIf="inProgress?.value=='true'">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        {{courseTestForm.value.id?'Updating...':'Saving...'}}
                    </ng-container>
                    <ng-container *ngIf="inProgress?.value!='true'">
                        <i class="bx bx-save"></i>{{courseTestForm.value.id?'Save Changes':'Save'}}
                    </ng-container>
                </button>
            </div>
        </div>
    </div>
</form>
<section class="rcx-table">
    <div class="row">
        <div class="col-lg-12">
            <div class="card btr">
                <div class="card-content">
                    <div class="card-body table-responsive" *ngIf="courseTestForm?.value?.id">
                        <h5 class="modal-title d-flex align-items-center">
                            <i class="bx bx-list-ul me-1 font-20 text-primary"></i>Course Test Questionnaire
                        </h5>
                        <form [formGroup]="courseTestQuestionnaireForm">
                            <table class="table" id="table">
                                <thead id="table-thead">
                                    <tr class="bg-light">
                                        <th scope="col" width="150" class="th-slide">
                                            <span class="d-flex align-items-center">
                                                <i class="bx bx-list-ul me-1 font-20 "></i>
                                                Category <b class="text-secondary">*</b>
                                            </span>
                                        </th>
                                        <th scope="col" width="100" class="th-slide">
                                            <span class="d-flex align-items-center">
                                                <i class="bx bx-dumbbell me-1 font-20 "></i>
                                                Weight <b class="text-secondary">*</b>
                                            </span>
                                        </th>
                                        <th scope="col" width="100" class="th-slide">
                                            <span class="d-flex align-items-center">
                                                <i class="bx bx-help-circle me-1 font-20 "></i>
                                                Max Qns <b class="text-secondary">*</b>
                                            </span>
                                        </th>
                                        <th scope="col" width="100" class="th-slide">
                                            <span class="d-flex align-items-center">
                                                <i class="bx bx-toggle-left me-1 font-20 "></i>
                                                Disabled
                                            </span>
                                        </th>
                                        <th scope="col" width="150" class="text-center th-slide">
                                            <span class="d-flex align-items-center justify-content-center">
                                                <i class="bx bx-cog me-1 font-20"></i>
                                                Actions
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody formArrayName="courseTestQuestionnaires">
                                    <tr *ngFor="let courseTestQuestionnaire of courseTestQuestionnaires.controls; let i=index"
                                        [formGroupName]="i">
                                        <td class="col-lg-6 px-0">
                                            <ng-select [items]="questionCategories" bindLabel="name" bindValue="id"
                                                placeholder="Select Category" formControlName="questionCategoryId"
                                                (change)="onCategoryChange($event, i)" [clearable]="false"
                                                class="ng-select-container"
                                                [ngClass]="{'is-invalid': submittedQuestionnaire && courseTestQuestionnaire.get('questionCategoryId')?.invalid}">
                                            </ng-select>
                                            <div class="invalid-feedback"
                                                *ngIf="submittedQuestionnaire && courseTestQuestionnaire.get('questionCategoryId')?.invalid">
                                                <span
                                                    *ngIf="courseTestQuestionnaire.get('questionCategoryId')?.errors?.required">Please
                                                    select a category.</span>
                                            </div>
                                        </td>
                                        <td class="col-lg-2">
                                            <input type="number" class="form-control form-control-sm"
                                                formControlName="weight" placeholder="Weight" required readonly
                                                [ngClass]="{'is-invalid': submittedQuestionnaire && courseTestQuestionnaire.get('weight')?.invalid}">
                                            <div class="invalid-feedback"
                                                *ngIf="submittedQuestionnaire && courseTestQuestionnaire.get('weight')?.invalid">
                                                <span
                                                    *ngIf="courseTestQuestionnaire.get('weight')?.errors?.required">Please
                                                    enter a weight.</span>
                                            </div>
                                        </td>
                                        <td class="col-lg-2">
                                            <input type="number" class="form-control form-control-sm"
                                                formControlName="maxQuestion" placeholder="Max Questions" required
                                                [ngClass]="{'is-invalid': submittedQuestionnaire && courseTestQuestionnaire.get('maxQuestion')?.invalid}">
                                            <div class="invalid-feedback"
                                                *ngIf="submittedQuestionnaire && courseTestQuestionnaire.get('maxQuestion')?.invalid">
                                                <span
                                                    *ngIf="courseTestQuestionnaire.get('maxQuestion')?.errors?.required">Please
                                                    enter max questions.</span>
                                            </div>
                                        </td>
                                        <td class="col-lg-3">
                                            <input type="checkbox" formControlName="disabled" class="form-check-input">
                                            <label class="form-check-label ms-2">Disabled</label>
                                        </td>
                                        <td class="actions">
                                            <i class="{{ courseTestQuestionnaire?.value?.id ? 'bx bx-edit' : 'bx bx-save' }} alert-primary mt-1"
                                                title="{{ courseTestQuestionnaire?.value?.id ? 'Edit Course Test Questionnaire' : 'Save Course Test Questionnaire'}}"
                                                *ngIf="!courseTestQuestionnaire?.isUpdateInProgress"
                                                (click)="upsertCourseTestQuestionnaire(courseTestQuestionnaire, i)">
                                            </i>
                                            <div *ngIf="courseTestQuestionnaire?.isUpdateInProgress" role="status"
                                                class="spinner-border spinner-border-sm text-primary">
                                                <span class="visually-hidden">Loading...</span>
                                            </div>
                                            <i *ngIf="!courseTestQuestionnaire?.isDeleteInProgress && courseTestQuestionnaires.controls.length > 1 && courseTestQuestionnaire.value.id"
                                                title="Delete Test Questionnaire"
                                                class="bx bx-trash alert-secondary mt-1"
                                                (click)="deleteCourseTestQuestionnaire(courseTestQuestionnaire,i)"></i>
                                            <div *ngIf="courseTestQuestionnaire?.isDeleteInProgress" role="status"
                                                class="spinner-border spinner-border-sm text-danger">
                                                <span class="visually-hidden">Loading...</span>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>